// extracted by mini-css-extract-plugin
module.exports = {"ErrorText":"requestMessageComponent_ErrorText__3RGLv","confirmationText":"requestMessageComponent_confirmationText__3uhSQ"};